/**
 * Объекты для общих стилей createUseStyles
 */
import { createUseStyles } from 'react-jss';

export const virtualListTableStyles = {
  tableWrapper: {
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
    border: '1px solid var(--table-border-color)',
    background: 'var(--table-body-color)',
  },
};
export const useVirtualListTableStyles = createUseStyles({
  ...virtualListTableStyles,
});

export const dialogContentContainerPropsClassNameStyles = {
  // children Dialog оборачивается неуправляемым div, данный стиль игнорирует его
  // вписать класс в атрибут Dialog'а contentContainerProps={{ className: ... }}
  displayContents: {
    '& > div': {
      display: 'contents',
    },
  },
};
export const useDialogStyles = createUseStyles({
  ...dialogContentContainerPropsClassNameStyles,
});

export const generalStyles = {
  header: {
    padding: '.25rem .5rem',
    zIndex: 1,
    display: 'grid',
    gridAutoFlow: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    columnGap: '.25rem',
    boxShadow: '0 4px 8px -5px rgba(0, 0, 0, .65)',
    /* без этого тень будет скрываться при накладки другого компонента, например при скроле в формы наблюдения */
    position: 'relative',
  },
};
export const useGeneralStyles = createUseStyles({
  ...generalStyles,
});
